export default {
	locationHeading: "Location",
	bioHeading: "Bio",
};
